<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }"
          :title="enterpriseFullName+'/'+discountContent+'/使用记录'">
    <search-page-view
      :col="4"
      ref="pageList"
      :itemNames="['companyEmail', 'employeeName','search_Phone']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="employeeId"
      :leftSpace="20"
      requestType="post"
      :requestPromise="loadDataList"
    >
      <a-form-item slot="companyEmail" label="公司邮箱" v-bind="searchItemLayout">
        <a-input v-model="queryParams.companyEmail" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-form-item slot="employeeName" label="姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.employeeName" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-form-item slot="search_Phone" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.phone " placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <template slot="deptIds" slot-scope="rowItem">
        {{ getDeptName(rowItem.record.deptIds, deptOptions) }}
      </template>
      <a-space slot="action" slot-scope="rowItem">
        <a v-if="!rowItem.record.balanceAmount" @click="onRechargeEvent(rowItem.record)">充值</a>
      </a-space>
    </search-page-view>
    <SimpleFormEditorDialog
      v-if="showDialog"
      :maskClosable="false"
      @cancel="showDialog=false"
      :title="selectItem?'编辑员工':'新增员工'"
      :rules="rules"
      :editConfigList="editConfigList"
      :item="selectItem"
      @ok="onSubmitEvent"
    >
      <template v-slot:deptIds="slotProps">
        <a-tree-select
          show-search
          style="width: 100%"
          v-model:value="slotProps.form['deptIds']"
          :placeholder="slotProps.item.placeholder"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          allow-clear
          multiple
          tree-default-expand-all
          :replaceFields="{
              children:'children',
              title:'deptName',
              key:'deptId',
              value: 'deptId'
          }"
          :tree-data="deptTreeData"
        >
        </a-tree-select>
      </template>

    </SimpleFormEditorDialog>
  </a-card>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import deptMixins from '@/views/platform/employeeVerification/mixins/deptMixins'
import employeeOptions from '@/views/platform/employeeVerification/mixins/employeeMixins'
import ValidatorHelper from '@/utils/helper/validatorHelper'

export default {
  name: 'EmployeeList',
  mixins: [searchForm, deptMixins, employeeOptions],
  components: {
    SimpleFormEditorDialog: SimpleFormEditorDialog
  },
  data() {
    return {
      columns: [
        {
          title: '员工ID',
          dataIndex: 'employeeId',
          width: '100px'
        },
        {
          title: '姓名',
          dataIndex: 'empName',
          width: '100px'
        },
        {
          title: '所属部门',
          dataIndex: 'deptIds',
          width: '200px',
          scopedSlots: { customRender: 'deptIds' }
        },
        {
          title: '公司邮箱',
          dataIndex: 'companyEmail',
          width: '200px'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          width: '120px'
        },
        {
          title: '充值金额',
          dataIndex: 'balanceAmount',
          width: '120px'
        },

        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryParams: {},
      rules: {
        empName: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        companyEmail: ValidatorHelper.createEmailRule('请输入公司邮箱', '公司邮箱格式有误'),
        phone: ValidatorHelper.createMobileRule(false, '请输入手机号', '手机号码格式有误'),
        deptIds: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ]
      },
      editConfigList: [
        {
          name: '姓名',
          key: 'empName',
          placeholder: '请输入姓名'
        },
        {
          name: '公司邮箱',
          key: 'companyEmail',
          placeholder: '请输入公司邮箱'
        },
        {
          name: '手机号',
          key: 'phone',
          placeholder: '请输入手机号'
        },
        {
          name: '部门',
          key: 'deptIds',
          slot: true,
          placeholder: '请选择部门'
        }
      ],
      deptOptions: [],
      rechargeLoading: false
    }
  },
  activated() {
    this.$refs.pageList?.refresh(false)
  },
  watch: {
    'enterpriseId': function(val) {
      if (this.enterpriseId) {
        this.refreshData(true)
      }
    },
    'deptTreeData': function(val) {
      if (this.deptTreeData) {
        this.deptOptions = this.treeToList(this.deptTreeData)
      }
    }
  },
  methods: {
    treeToList(list) {
      if (list && list.length > 0) {
        const newList = []
        list.forEach(item => {
          newList.push({
            ...item,
            children: undefined
          })
          const children = this.treeToList(item.children)
          if (children) {
            newList.push(...children)
          }
        })
        return newList
      }
      return undefined
    },
    loadDataList(params) {
      const data = { ...params, enterpriseId: this.enterpriseId }
      return this.getHttpServices().getMemberAuthService().post('member/v3/auth/getEmployeeFirstRechargeList', data)
    },
    getDeptName(deptIds, options) {
      if (options && options.length) {
        return deptIds.map(id => {
          const findItem = options.find(item => String(item.deptId) === String(id))
          return findItem ? findItem.deptName : id
        }).join(',')
      }
      return deptIds.join(',')
    },
    onRechargeEvent(item) {
      if (this.rechargeLoading) {
        return
      }
      this.rechargeLoading = true
      const url = 'member/v3/auth/editAuthEmployeeRecharge'
      const params = {
        employeeId: item.employeeId
      }
      this.getHttpServices().getMemberAuthService().post(url, params)
        .then(res => {
          this.refreshData(false)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          console.error(err)
          this.rechargeLoading = false
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          this.refreshData(false)
        })
    },
    refreshData(reset) {
      this.$refs.pageList.refresh(reset)
    },
    onSubmitEvent(params) {
      const data = { ...params, enterpriseId: this.enterpriseId }
      this.getHttpServices().getMemberAuthService().post('member/v3/auth/saveAuthEmployee', data)
        .then(res => {
          this.selectItem = undefined
          this.showDialog = false
          this.refreshData(!!params.employeeId)
          this.$message.success('操作成功！')
        })
        .catch(err => {
          console.error(err)
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
    }
  }
}
</script>
<style scoped lang="less">

</style>